import { CSSProperties, ReactNode } from 'react';
import { Box as MUIBox, BoxProps as MUIBoxProps } from '@mui/material';

type AtomMUIProps = {
  children?: ReactNode;
  className?: string;
  style?: CSSProperties;
  sx?: MUIBoxProps['sx'];
};

export type BoxProps = AtomMUIProps;

export const Box = (props: BoxProps) => {
  const MUIProps: MUIBoxProps = props;

  return <MUIBox {...MUIProps} />;
};

export default Box;
